import type { HeroSlide, NewsItem } from "../types";

export const heroSlides: HeroSlide[] = [
  {
    movieId: 1,
    title: "星海彼岸",
    subtitle: "人类最深处的孤独，与星海尽头的答案",
    tag: "重磅上新",
    backdrop: "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20hero%20banner%2C%20vast%20deep%20space%20nebula%20in%20teal%20and%20gold%20with%20a%20lone%20astronaut%20silhouette%20before%20a%20giant%20ringed%20planet%2C%20dramatic%20volumetric%20light%2C%20epic%20wide%20composition%20with%20dark%20edges%20for%20text&width=1920&height=1080&seq=hero-slide-01&orientation=landscape",
  },
  {
    movieId: 4,
    title: "钢铁纪元",
    subtitle: "一个人，一台钢铁巨兽，改写整个纪元",
    tag: "热映中",
    backdrop: "https://readdy.ai/api/search-image?query=Epic%20action%20hero%20banner%2C%20a%20towering%20mecha%20robot%20standing%20before%20a%20futuristic%20industrial%20skyline%20at%20dusk%2C%20cool%20steel%20blue%20tones%20with%20glowing%20amber%20sparks%2C%20dramatic%20cinematic%20wide%20composition&width=1920&height=1080&seq=hero-slide-02&orientation=landscape",
  },
  {
    movieId: 3,
    title: "云上之光",
    subtitle: "守在云巅二十年，只为等一个答案",
    tag: "口碑佳作",
    backdrop: "https://readdy.ai/api/search-image?query=Warm%20drama%20hero%20banner%2C%20a%20lone%20figure%20standing%20on%20a%20mountain%20hilltop%20above%20an%20endless%20sea%20of%20golden%20sunrise%20clouds%2C%20hopeful%20soft%20amber%20light%2C%20cinematic%20wide%20composition%20with%20gentle%20haze&width=1920&height=1080&seq=hero-slide-03&orientation=landscape",
  },
  {
    movieId: 2,
    title: "暗夜追凶",
    subtitle: "所有线索，都回到那场被掩埋的火灾",
    tag: "悬疑新高",
    backdrop: "https://readdy.ai/api/search-image?query=Crime%20thriller%20hero%20banner%2C%20a%20rainy%20neon-lit%20city%20street%20at%20night%20with%20a%20lone%20detective%20silhouette%20and%20glowing%20wet%20reflections%2C%20moody%20teal%20and%20amber%20tones%2C%20cinematic%20wide%20composition&width=1920&height=1080&seq=hero-slide-04&orientation=landscape",
  },
];

export const news: NewsItem[] = [
  {
    id: 1,
    title: "《星海彼岸》点映口碑出炉，被赞“十年最强科幻构筑”",
    date: "2026-10-11",
    tag: "新片动态",
    summary:
      "影片凭借扎实的科幻设定与细腻的情感刻画收获大量好评，导演陈屿表示故事的核心始终是“人”，而非特效本身。",
    movieId: 1,
  },
  {
    id: 2,
    title: "科幻巨制《钢铁纪元》全球票房突破 8 亿美元",
    date: "2026-10-10",
    tag: "票房快讯",
    summary:
      "上映两周，影片在北美与亚洲市场表现强劲，机甲设计成为社交平台热议话题，续集已正式官宣进入筹备。",
    movieId: 4,
  },
  {
    id: 3,
    title: "《深渊回响》发布全新深海概念预告，压迫感拉满",
    date: "2026-10-08",
    tag: "预告发布",
    summary:
      "官方放出两分钟概念预告，全程无对白却张力十足，被网友称为“光听音效就让人窒息”的年度惊悚期待作。",
    movieId: 9,
  },
  {
    id: 4,
    title: "温情片《云上之光》定档，真实故事改编引期待",
    date: "2026-10-06",
    tag: "定档资讯",
    summary:
      "影片改编自乡村教师的真实经历，主创团队深入高原取景三个月，力求还原最质朴的坚守与感动。",
    movieId: 3,
  },
  {
    id: 5,
    title: "《幻境迷宫》续作立项，原班主创确认回归",
    date: "2026-10-04",
    tag: "项目立项",
    summary:
      "凭借出色的视觉设计与烧脑叙事，影片全球收获好评，制片方正式宣布续作将延续迷宫世界观并升级视效。",
    movieId: 12,
  },
  {
    id: 6,
    title: "《山海奇缘》上线流媒体，合家欢口碑持续走高",
    date: "2026-10-02",
    tag: "平台上线",
    summary:
      "这部国风动画以独特的山海世界观和温暖内核打动全年龄观众，上线后连续多日占据合家欢观影榜前列。",
    movieId: 17,
  },
];

export const siteStats = [
  { label: "收录影片", value: "12,800+" },
  { label: "精选专题", value: "320+" },
  { label: "日均影迷", value: "86万" },
  { label: "平均评分", value: "8.4" },
];